<p-floatLabel>
  <p-select #evaluationStateDropdown
            id="evaluationStateDropdown"
            name="evaluationStateDropdown"
            [options]="evaluationStates"
            [(ngModel)]="evaluationState"
            [showClear]="!isRequired"
            [checkmark]="true"
            [disabled]="isReadOnly"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="evaluationStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
